module.exports = __webpack_public_path__ + "static/media/microscope.8fba1b1f.svg";